import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Textarea, Typography } from 'foundations-library/components'
import InfoSection from '../../InfoSection'
import { TextareaType } from 'foundations-library/type'
import RedAsterisk from '../../RedAsterisk'

const jss = () => ({
    inputLabel: {
        marginBottom: 15
    },
    mb10: {
        marginBottom: 10
    },
    mb30: {
        marginBottom: 30
    },
    textarea: {
        marginBottom: 20
    },
    inputContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 30
    }
})

const useStyles = makeStyles(jss)

type PropsInterface = {
    info?: string,
    label?: string
} & TextareaType

/**
 *
 */
const LabelTextareaInfo = ({
    info = '',
    label = '',
    minHeight = 150,
    ...props
}: PropsInterface): JSX.Element => {
    const styles = useStyles()
    return <div>
        <div>
            <Typography variant='body1' className={styles.inputLabel}>
                {label}<RedAsterisk />
            </Typography>
            <Textarea
                minHeight={minHeight}
                {...props}
                className={styles.textarea}
            />
        </div>
        {info && <InfoSection>
            <Typography variant='subtitle1' className={styles.mb10}>
                Sample description
            </Typography>
            {info}
        </InfoSection>}
    </div>
}

export default LabelTextareaInfo
